module.exports = __webpack_public_path__ + "static/img/sbts.efc4b1c9.png";